import { isToday, startOfDay } from 'date-fns';

export const getLocalDateKey = (isoDateStr: string): string => {
  return startOfDay(new Date(isoDateStr)).toISOString().split('T')[0];
};

export const isSameLocalDate = (
  dateStr1: string,
  dateStr2: string
): boolean => {
  return getLocalDateKey(dateStr1) === getLocalDateKey(dateStr2);
};

export const formatDateHeader = (
  dateStr: string,
  t: (key: string) => string
): string => {
  const date = new Date(dateStr);

  if (isToday(date)) {
    return t('whatsNew:today');
  }

  return new Intl.DateTimeFormat(navigator.language, {
    weekday: 'long',
    month: 'long',
    day: 'numeric',
    year: 'numeric',
  }).format(date);
};
